var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0C8.59644 0 3 5.73075 3 12.8C3 21.5478 10.2917 27.7333 15.5 32C20.7083 27.7333 28 21.5478 28 12.8C28 5.73075 22.4036 0 15.5 0Z",
    fill: "#F34F42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.707 9.2928C22.8946 9.48033 23 9.73465 23 9.99983C23 10.265 22.8946 10.5193 22.707 10.7069L14.6998 18.7072C14.5121 18.8947 14.2576 19 13.9922 19C13.7268 19 13.4722 18.8947 13.2845 18.7072L9.28096 14.707C9.09864 14.5184 8.99776 14.2658 9.00004 14.0036C9.00232 13.7414 9.10758 13.4906 9.29316 13.3052C9.47873 13.1197 9.72977 13.0146 9.9922 13.0123C10.2546 13.01 10.5075 13.1108 10.6962 13.293L13.9922 16.5861L21.2917 9.2928C21.4794 9.10532 21.7339 9 21.9993 9C22.2647 9 22.5193 9.10532 22.707 9.2928Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedPin);
export default __webpack_public_path__ + "static/media/selectedPin.9a36f4e8309bdadb078e8d2313c01673.svg";
export { ForwardRef as ReactComponent };